import { render, staticRenderFns } from "./stateItem.vue?vue&type=template&id=12bde87c&scoped=true"
import script from "./stateItem.vue?vue&type=script&lang=js"
export * from "./stateItem.vue?vue&type=script&lang=js"
import style0 from "./stateItem.vue?vue&type=style&index=0&id=12bde87c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bde87c",
  null
  
)

export default component.exports